import { RootState } from '.'
import { ActionTypes } from '../actions/purgatory'
import FixtureConfig from '../types/FixtureConfig'

export interface PurgatoryState {
    fixtureCode: string
    fixtureConfig?: FixtureConfig
    isLoading: boolean
    error?: string
}

const initialState: PurgatoryState = {
    fixtureCode: '',
    fixtureConfig: undefined,
    isLoading: false,
    error: undefined,
}

export default (state: PurgatoryState = initialState, { type, payload }: any) => {
    switch (type) {
        case ActionTypes.FETCH_FIXTURE_CODE_REQUEST: {
            return {
                ...state,
                error: initialState.error,
                isLoading: true,
            }
        }
        case ActionTypes.FETCH_FIXTURE_CODE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                fixtureConfig: {
                    ...payload,
                },
            }
        }
        case ActionTypes.FETCH_FIXTURE_CODE_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: payload.message,
            }
        }
        default:
            return state
    }
}

export function getFixtureConfig(state: RootState) {
    return state.purgatory.fixtureConfig
}

export function getFixtureConfigError(state: RootState) {
    return state.purgatory.error
}
